import seo_ar from './static/argentina/seo';
import seo_br from './static/brasil/seo';

export const GetSeoInfo = () => {
  let language = process.env.RAZZLE_LANGUAGE || window.env.RAZZLE_LANGUAGE;
  language = language.trim();
  const country = language.slice(language.length - 2, language.length).toUpperCase();

  switch (country) {
    case 'BR':
      return seo_br;
    default:
      return seo_ar;
  }
};
